import Vue from "vue";
import Vuex from "vuex";
import createPersistedState from "vuex-persistedstate";

Vue.use(Vuex);

// Vuexインスタンス生成
export default new Vuex.Store({
    state: {
        userName: "",
        roles: "",
        school_code: "",
        school_name: "",
        menuItems: [],
        gameId: "", // gameIdを追加
        gameInfoId: "", // gameInfoIdを追加
    },
    getters: {
        userName(state) {
            return state.userName;
        },
        roles(state) {
            return state.roles;
        },
        schoolCode(state) {
            return state.school_code;
        },
        schoolName(state) {
            return state.school_name;
        },
        menuItems(state) {
            return state.menuItems;
        },
        gameId(state) {
            return state.gameId; // gameIdのgetterを追加
        },
        gameInfoId(state) {
            return state.gameInfoId; // gameInfoIdのgetterを追加
        },
    },
    mutations: {
        setUserName(state, value) {
            state.userName = value;
        },
        setRoles(state, value) {
            state.roles = value;
        },
        setSchoolCode(state, value) {
            state.school_code = value;
        },
        setSchoolName(state, value) {
            state.school_name = value;
        },
        setMenuItems(state, value) {
            state.menuItems = value;
        },
        setGameId(state, value) {
            state.gameId = value; // gameIdのmutationを追加
        },
        setGameInfoId(state, value) {
            state.gameInfoId = value; // gameInfoIdのmutationを追加
        },
    },
    plugins: [
        createPersistedState({
            key: "tournament",
            storage: window.sessionStorage,
        }),
    ],
});
